import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import { DialogContentText } from '@mui/material';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'components/Dialog';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export enum ContentLockedAction {
  Screenshare = 'screenshare',
  WhiteboardCreate = 'whiteboard_create',
  WhiteboardOpen = 'whiteboard_open',
  FileOpen = 'file_open',
}

const ContentLockedByModeratorModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();
  const modalData = useAppSelector(selectActiveModalData);

  const action = (modalData.contentAction as ContentLockedAction) || ContentLockedAction.FileOpen;

  const hideModal = () => dispatch(closeModal('contentLockedByModerator'));

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="content-locked-by-moderator-dialog"
      aria-describedby="content-locked-by-moderator-description"
      onClose={hideModal}
      open
    >
      <DialogTitle id="content-locked-by-moderator-dialog" onClose={hideModal}>
        {t(`content_locked_by_moderator.${action}.title`)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="content-locked-by-moderator-description">
          {t(`content_locked_by_moderator.${action}.description`)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={hideModal} color="grayscale">
          {t('content_locked_by_moderator.btn_ok_label')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContentLockedByModeratorModal;
